export default __webpack_public_path__ + "static/section_4_details_5-3875bb68d3351e7d2b59940592dfdcef.png";